import { useLang, CATEGORIES, catLabel } from "@/lib/i18n";

export const CalendarLegend = ({ categoryColors, events }) => {
  const { t } = useLang();
  const colors = categoryColors || {};
  const present = new Set((events || []).map((e) => e.category || "other"));
  const keys = [
    ...CATEGORIES.filter((c) => colors[c] && present.has(c)),
    ...Object.keys(colors).filter((c) => !CATEGORIES.includes(c) && present.has(c)).sort(),
  ];
  if (keys.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-4" data-testid="calendar-legend">
      {keys.map((c) => (
        <span key={c} className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <span className="h-2.5 w-2.5 rounded-sm shrink-0 border border-muted-foreground/40" style={{ background: colors[c] }} />
          {catLabel(t, c)}
        </span>
      ))}
    </div>
  );
};
